import { LocationOn, AccountBalanceWallet } from '@mui/icons-material';
import {
  GridLegacy as Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { Button } from '@rumblefish/ui/Rumblefish23Theme';
import { NextLink } from '@rumblefish/ui/src/components/NextLink';
import React from 'react';
import type { OpeningItemProps } from './OpeningItem.types';
import { StyledCard, StyledTitle } from './styles';

export const OpeningItem: React.FC<OpeningItemProps> = ({ opening }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const smDown = useMediaQuery(theme.breakpoints.down('sm'));

  const iconsColor = theme.palette.orangeColors?._0;
  return !isMobile ? (
    <StyledCard>
      <Stack
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          width: '100%',
          gap: '1rem',
        }}>
        <StyledTitle variant="strong_600" color={'#fff'}>
          <NextLink
            href={`/careers/${opening.slug}/`}
            sx={{
              width: '100%',
              textDecoration: 'none',
              color: 'inherit',
            }}>
            {opening?.title}
          </NextLink>
        </StyledTitle>
        <Stack sx={{ gap: '0.5rem' }}>
          <Typography
            variant="body2Big"
            component="div"
            sx={{
              color: '#e0e0e0',
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
            }}>
            <LocationOn
              sx={{
                color: iconsColor,
              }}
            />
            {opening?.location}
          </Typography>
          <Typography
            variant="bodySmall"
            component="div"
            sx={{
              color: '#e0e0e0',
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
            }}>
            <AccountBalanceWallet
              sx={{
                color: iconsColor,
              }}
            />
            {opening?.salary}
          </Typography>
        </Stack>
      </Stack>
      <Button
        secondaryVariant
        shadowColor="orange"
        href={`/careers/${opening.slug}/`}
        sx={{
          marginLeft: 'auto',
          minWidth: '140px',
        }}>
        Apply
      </Button>
    </StyledCard>
  ) : (
    <StyledCard>
      <Grid
        container
        rowSpacing={3}
        sx={{ display: 'flex', alignItems: 'space-between', width: '100%' }}>
        <Grid
          xs={12}
          sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          <StyledTitle variant="strong_600" color={'#fff'}>
            <NextLink
              href={`/careers/${opening?.slug}/`}
              sx={{
                width: '100%',
                textDecoration: 'none',
                color: 'inherit',
              }}>
              {opening?.title}
            </NextLink>
          </StyledTitle>
        </Grid>
        <Grid xs={12} sm={6}>
          <Typography
            variant="body2Big"
            component="div"
            sx={{
              color: '#e0e0e0',
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
            }}>
            <LocationOn
              sx={{
                color: iconsColor,
              }}
            />
            {opening?.location}
          </Typography>
          <Typography
            variant="bodySmall"
            component="div"
            sx={{
              color: '#e0e0e0',
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
            }}>
            <AccountBalanceWallet
              sx={{
                color: iconsColor,
              }}
            />
            {opening?.salary}
          </Typography>
        </Grid>
        <Grid
          xs={12}
          sm={6}
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            width: '100%',
          }}>
          <NextLink
            href={`/careers/${opening?.slug}/`}
            sx={{
              width: smDown ? '100%' : 'auto',
            }}>
            <Button
              secondaryVariant
              shadowColor="orange"
              sx={{
                marginBlock: '0.5rem',
                width: '100%',
              }}>
              Apply
            </Button>
          </NextLink>
        </Grid>
      </Grid>
    </StyledCard>
  );
};
